import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, ref, watch } from 'vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useCourse from '@/composables/useCourse'
  import { DateTime } from 'luxon'
  import useI18n from '@/composables/useI18n'
  import { CourseModule } from '@/store/modules/course'
  import useShopifyClient from '@/composables/useShopifyClient'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'InTrialCourseTimer',
  setup(__props) {

  const { course } = useCourse()
  const { translateString } = useI18n()
  const { daysDifferenceFromNow } = useCommonMixin()
  const { createShopifyCheckout } = useShopifyClient()

  const usedTrialDays = ref(0)

  const timeTrialStarted = computed(() => course.value?.timeTrialStarted)

  const maxTrialDays = computed(() => Number(process.env.VUE_APP_MAX_COURSE_TRIAL_DAYS) || 7)

  const trialDaysLeft = computed(() => maxTrialDays.value - usedTrialDays.value)

  const daysLeftText = computed(() => {
    if (trialDaysLeft.value <= 0) return translateString('courses.courseTrials.freeAccessHasExpired')
    return translateString('courses.courseTrials.onlyXDaysLeft', { days: trialDaysLeft.value })
  })

  const setUsedTrialDays = () => {
    if (!timeTrialStarted.value) {
      const currentTimeISO = DateTime.now().toISO() as string
      usedTrialDays.value = daysDifferenceFromNow(currentTimeISO)
    } else {
      usedTrialDays.value = daysDifferenceFromNow(timeTrialStarted.value)
    }
  }

  const shopifyCheckout = async () => {
    await createShopifyCheckout()
  }

  watch(trialDaysLeft, (value) => {
    if (value <= 0) {
      CourseModule.setCourseTrialPeriodExpired(true)
    }
  })

  setUsedTrialDays()

  onBeforeUnmount(() => {
    CourseModule.setCourseTrialPeriodExpired(false)
  })

return { __sfc: true,course, translateString, daysDifferenceFromNow, createShopifyCheckout, usedTrialDays, timeTrialStarted, maxTrialDays, trialDaysLeft, daysLeftText, setUsedTrialDays, shopifyCheckout, computed, onBeforeUnmount, ref, watch, useCommonMixin, useCourse, DateTime, useI18n, CourseModule, useShopifyClient }
}

})